var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-box"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_vm._t("title")],2),_c('div',{staticClass:"card-title"},[_vm._t("owner")],2),_c('div',{staticClass:"card-body"},[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }